import React from "react";
import { ICONS } from "assets/icons";
import PremiumIcon from "assets/customSVG/PremiumIcon";

const HomeHeader = ({ displayName, brandName, onUpgrade, showUpgrade = true }) => {
  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-2xl bg-[var(--accent-soft)] text-[var(--accent-2)] grid place-items-center text-xl font-semibold shadow-sm">
          👋
        </div>
        <div>
          <h1 className="text-[var(--textBlack)] text-[28px] leading-8 font-semibold flex items-center flex-wrap gap-2">
            Welcome{displayName ? ',' : ''}{' '}
            {displayName && (
              <span className="bg-[#DCF5E9] py-1 px-2 rounded-lg flex items-center">
                {displayName}
                <img
                  src={ICONS?.heartEyeEmoji}
                  alt="heartEyeEmoji"
                  className="pl-3"
                />
              </span>
            )}
          </h1>
          <p className="text-[#616874] text-sm mt-1">
            A quick snapshot of how {brandName || 'your brand'} is performing today.
          </p>
        </div>
      </div>

      {showUpgrade && (
        <button
          className="flex items-center gap-2 rounded-full px-4 py-2 bg-[var(--surface-strong)] text-white font-medium shadow-[0_10px_30px_-18px_rgba(0,0,0,0.55)] hover:-translate-y-0.5 transition"
          type="button"
          onClick={onUpgrade}
        >
          <PremiumIcon width={18} height={18} />
          Upgrade
        </button>
      )}
    </div>
  );
};

export default HomeHeader;
